export default __webpack_public_path__ + "static/media/so-token.26ece789.png";